const Main = () => import('@/views/Main.vue')

const appuserRouter = {
    path: '/appuser',
    name: 'Appuser',
    component: Main,
    icon: require(`@/assets/images/menu-icons/icon_appuser_20_20.png`),
    icon_active: require(`@/assets/images/menu-icons/icon_appuser_hover_20_20.png`),
    children: [
        {
            path: 'driver-appuser',
            name: 'DriverMaterial',
            component: () => import('@/views/Material/DriverMaterial.vue'),
            meta: {
                title: '司机资料',
                roles: ['driver-appuser']
            }
        },
        {
            path: 'owner-appuser',
            name: 'ShipperMaterial',
            component: () => import('@/views/Material/ShipperMaterial.vue'),
            meta: {
                title: '货主资料',
                roles: ['owner-appuser']
            }
		
        },
		{
		    path: 'salesman-appuser',
		    name: 'SalesmanMaterial',
		    component: () => import('@/views/Material/SalesmanMaterial.vue'),
		    meta: {
		        title: '业务员资料',
		        roles: ['owner-appuser']
				}
			},
			{
			    path: 'shipperInto-appuser',
			    name: 'ShipperIntoMaterial',
			    component: () => import('@/views/Material/ShipperIntoMaterial.vue'),
			    meta: {
			        title: '货主转化记录',
			        roles: ['owner-appuser']
			    }
				},
        {
            path: 'recommend-appuser',
            name: 'Recommend',
            component: () => import('@/views/Material/Recommend.vue'),
            meta: {
                title: '推荐记录',
                roles: ['recommend-appuser']
            }
        }
    ],
    meta: {
        title: '资料管理',
        roles: ['appuser']
    }
}

export default appuserRouter